import { render, staticRenderFns } from "./mProveSettings.vue?vue&type=template&id=1a3642c0&class=p-1&"
import script from "./mProveSettings.vue?vue&type=script&lang=js&"
export * from "./mProveSettings.vue?vue&type=script&lang=js&"
import style0 from "./mProveSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mProveSettings.vue
// module id = null
// module chunks = 